/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Col_Total_LinesInputs */

const vi_stocktake_col_total_lines = /** @type {(inputs: Stocktake_Col_Total_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lô`)
};

/**

* @param {Stocktake_Col_Total_LinesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_col_total_lines = /** @type {((inputs?: Stocktake_Col_Total_LinesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Col_Total_LinesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_col_total_lines(inputs)
});